import { connect } from "react-redux";

import { ReactElement } from "react";
// import { __Utils } from "../../../_core/core";
import { NO_TOTAL_NUMBERS } from "../../config/Game";

import DrawWinItem from "./Draw.winItem";

interface DrawWinInterface {
  winningNumbers: any[];
  drawStart: boolean;
}

const DrawWin = ({ winningNumbers }: DrawWinInterface): null | ReactElement => {
  if (!winningNumbers.length) return null;

  return (
    <>
      {[...new Array(NO_TOTAL_NUMBERS)].map(
        (_el, _index) =>
          winningNumbers.indexOf(_index + 1) !== -1 ? (
            <DrawWinItem
              number={_index + 1}
              isDraw={winningNumbers.indexOf(_index + 1) !== -1}
              key={`DrawWinItem${_index}`}
            />
          ) : null
        //  _index +  1 > 79 ? <DrawWinItem number={_index+1} isDraw={ winningNumbers.indexOf(_index+1) !== -1 } key={ `DrawWinItem${_index}` }/>: null
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    drawStart: state.game.GAMEPLAY.drawStart,
  };
};

export default connect(mapStateToProps, {})(DrawWin);
